import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { setFilters } from '@features/tickets/models/filters';
import { FilterToolbar } from '@features/toolbarFilter';
import { SortToolbar } from '@features/toolbarSort';
import { orders } from '@features/toolbarSort/types';
import { sortFilterToolbarId } from '..';
import {
  $filters,
  $isFiltersApply,
  filtersSubmitted,
  sortChanged,
  sortingReadyChanged,
} from '../../../models';
import * as Styled from '../styled';

export const SortFilterToolbar = () => {
  const { t } = useTranslation();
  const [filters, isFiltersApply] = useUnit([$filters, $isFiltersApply]);

  const sortConfig = {
    id: sortFilterToolbarId,
    columns: [
      {
        id: 'updated_at',
        field: t('byUpdateDate'),
      },
      {
        id: 'created_at',
        field: t('byCreatedAt'),
      },
      {
        id: 'planned_date',
        field: t('byPlannedDate'),
      },
      {
        id: 'number',
        field: t('byNumber'),
      },
    ],
    canReset: false,
    default: {
      column: 'created_at',
      order: orders.desc,
    },
  };

  const setFiltersForToolbar = (filters: any) => {
    setFilters(filters);
  };

  const filterConfig = { id: 'tickets-filter' };

  return (
    <Styled.SortFilterToolbar>
      <SortToolbar
        config={sortConfig}
        outerSortChanged={sortChanged}
        sortingReadyChanged={sortingReadyChanged}
      />

      <FilterToolbar
        config={filterConfig}
        filters={filters}
        isFilterDefault={!isFiltersApply}
        resetFilters={() => filtersSubmitted('')}
        setFiltersOutside={setFiltersForToolbar}
      />
    </Styled.SortFilterToolbar>
  );
};
